import { childrenAuthorizationsDetailBreadcrumbs } from '../../../config';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuthorization } from '../../../hooks';
import { useMemo } from 'react';

const useViewAuthorization = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => childrenAuthorizationsDetailBreadcrumbs(navigate),
    [navigate]
  );

  const { authorization, isAuthorizationLoading } = useAuthorization(id || '');

  const missingTableData = useMemo(
    () => authorization?.discrepancies?.pickedUpButNotArrivedShippings ?? [],
    [authorization]
  );

  const surplusTableData = useMemo(
    () => authorization?.discrepancies?.arrivedButNotPickedUpShippings ?? [],
    [authorization]
  );

  const matchedTableData = useMemo(
    () => authorization?.discrepancies?.pickedUpAndArrivedShippings ?? [],
    [authorization]
  );

  return {
    breadcrumbs,
    authorization,
    isAuthorizationLoading,
    missingTableData,
    surplusTableData,
    matchedTableData,
  };
};

export default useViewAuthorization;
